<p-button icon="fas fa-upload" [label]="app.t('general.uploadFile')" (onClick)="upload()">
</p-button>
@if (value != null && value != '') {
    <p-button class="ml-3" icon="fas fa-trash" [label]="app.t('general.remove')" (onClick)="remove()">
    </p-button>
        <div>
        <img class="mt-2 uploadedImage" [src]="'data:image/png;base64,' + value"/>
    </div>
}
